import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import Scrollbar from "../components/scrollbar";
import MegaspinsTable from "src/components/megaspins-table/MegaspinsTable";
import MegaspinDialog from "src/components/megaspins-table/MegaspinDialog";
import { get } from "src/utils/networkUtils";

export default function MegaspinsPage() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [megaspinEdit, setMegaspinEdit] = useState(null);

  useEffect(() => {
    get(`/admin/megaspins`).then(function (response) {
      setLoading(false);
      setRows(response.megaspinPeriods);
    });
  }, []);
  console.log("megaspinEdit", megaspinEdit);
  return (
    <>
      <Helmet>
        <title> Mega Spins </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Mega Spins
          </Typography>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <MegaspinsTable rows={rows} onEdit={setMegaspinEdit} />
            </Scrollbar>
          )}
        </Card>
      </Container>
      <MegaspinDialog
        open={megaspinEdit !== null}
        megaspin={megaspinEdit}
        onClose={() => setMegaspinEdit(null)}
        onSuccessHandler={() => {
          window.location.reload();
        }}
      />
    </>
  );
}
